export default __webpack_public_path__ + "static/media/logo_footer.24a3f65a.svg";